// Location accent colors for the schedule calendar (Task 5). Keyed by
// location slug per the admin-UI plan's Global Constraints, so today's
// seed locations get stable, distinct colors. A location added later
// (a fifth office, etc.) falls back to a deterministic rotation keyed off
// a hash of the slug, so a given slug always renders the same fallback
// color across reloads/sessions rather than a random one.
const LOCATION_COLORS: Record<string, string> = {
  "denver-baker": "#2563eb",
  "denver-florida-ave": "#16a34a",
  "wheat-ridge-youngfield": "#d97706",
  virtual: "#9333ea",
};

// Time-off blocks (provider-only, no location) render in this gray
// everywhere the schedule calendar shows them, including the legend.
export const BLOCK_COLOR = "#6b7280";

// Fallback palette for a location slug not in LOCATION_COLORS above.
// Deliberately distinct from both the known location colors and
// BLOCK_COLOR's gray.
const FALLBACK_ROTATION: readonly string[] = [
  "#0891b2",
  "#c026d3",
  "#65a30d",
  "#dc2626",
  "#0f766e",
];

// Simple deterministic string hash (djb2-ish) — good enough to pick a
// stable index into FALLBACK_ROTATION; not used for anything
// security-sensitive.
function hashSlug(slug: string): number {
  let hash = 0;
  for (let i = 0; i < slug.length; i++) {
    hash = (hash * 31 + slug.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

export function colorForLocation(slug: string): string {
  const known = LOCATION_COLORS[slug];
  if (known) return known;
  return FALLBACK_ROTATION[hashSlug(slug) % FALLBACK_ROTATION.length]!;
}
